module.exports = __webpack_public_path__ + "static/media/coffee.073263b3.svg";